import BaseWrapper from "../../components/BaseWrapper/BaseWrapper"
import Content from "./Content"

const Reporting = () => <BaseWrapper content={<Content/>}/>

export default Reporting